import { breakpoint, colors, fontFamily, fontSize, fontWeight, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  faqWrapper: css({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.catskillWhite,
    width: '100%',
    margin: 'auto',
    alignItems: 'center',
    padding: '40px 0',
    overflow: 'hidden',
    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: '100px 0',
    },
  }),

  heading: css({
    color: '#131F4A',
    fontSize: 32,
    lineHeight: '145%',
    fontWeight: fontWeight.bold,
    margin: 0,
  }),

  qaCards: css({
    padding: shorthandHelper([spacing.large]),
  }),

  flexContainer: css({
    display: 'flex',
    flexDirection: 'column',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  footerContainer: css({
    display: 'flex',
    flexDirection: 'column',
    color: '#131F4A',
    fontSize: '20px',
    lineHeight: '54px',
    fontWeight: fontWeight.bold,

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'column',
    },
  }),

  footerButton: css({
    display: 'flex',
    textDecoration: 'none',
    cursor: 'pointer',
    margin: 'auto',
    backgroundColor: colors.cornflowerBlue,
    borderRadius: '6px',
    fontSize: fontSize.default,
    fontFamily: fontFamily.default,
    fontWeight: fontWeight.semiBold,
    textAlign: 'center',
    padding: shorthandHelper([spacing.default, spacing.medium]),
    color: colors.white,
    lineHeight: '27px',
    transition:
      'transform .3s cubic-bezier(.55, .085, .68, .53),background-color .3s cubic-bezier(.55, .085, .68, .53),box-shadow .2s,-webkit-transform .3s cubic-bezier(.55, .085, .68, .53)',

    '&:hover': {
      backgroundColor: '#2E71C1 !important',
      boxShadow: '0 2px 4px rgb(0 0 0 / 10%)',
      transform: 'scale(1.04)',
      fontWeight: fontWeight.semiBold,
    },
  }),

  link: css({
    color: '#2f96f4',
    textDecoration: 'none',
  }),
}

export default styles
